import { render, staticRenderFns } from "./wpPictureUi.vue?vue&type=template&id=accfeab2"
import script from "./wpPictureUi.vue?vue&type=script&lang=js"
export * from "./wpPictureUi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports